import {
	Disclaimer,
	Reference,
} from '@volkswagen-onehub/disclaimer-manager/dist-es/api';
import {
	CarlineWithOfertas,
	Oferta,
} from '../services/ofertas-service/models/ofertas';
import { getDatosEconomicos } from './ofertas-helper';

export interface RegisteredDisclaimer {
	readonly text: string;
	readonly ref: Reference | undefined;
	readonly type: 'legal' | 'legal cuota';
}

export const getDisclaimers = (
	carlines: CarlineWithOfertas[],
): RegisteredDisclaimer[] => {
	const FOOTER_DISCLAIMER =
		'El responsable del tratamiento de tus datos es VOLKSWAGEN GROUP ESPAÑA DISTRIBUCIÓN, S.A.U., con la finalidad de atender tu solicitud de contacto y tus consultas. Te informamos que tienes derecho a retirar tu consentimiento en cualquier momento, así como a oponerte al tratamiento, limitar el mismo, acceder, rectificar, suprimir los datos y ejercer tu derecho a la portabilidad, mediante petición escrita a atencioncliente@volkswagen.es Puedes consultar con mayor detalle la información adicional sobre protección de datos aquí: https://www.volkswagen.es/es/volkswagen-espana/politica-privacidad.html';

	const disclaimers: RegisteredDisclaimer[] = [
		{ ref: '1', text: FOOTER_DISCLAIMER, type: 'legal' },
	];

	let disclaimerPostion = Number(disclaimers[0].ref);

	carlines.forEach((carline) =>
		carline.ofertas.slice(0, 2).forEach((oferta) => {
			const selectedDatosEconomicos = getDatosEconomicos(
				oferta.datosEconomicos,
			);

			selectedDatosEconomicos.map((datoEconomico) => {
				if (datoEconomico?.legal) {
					disclaimerPostion++;
					disclaimers.push({
						ref: `${disclaimerPostion.toString()}.`,
						text: datoEconomico.legal,
						type:
							datoEconomico.periodicidad == 'pago-unico'
								? 'legal'
								: 'legal cuota',
					});
				}
			});
		}),
	);

	return disclaimers;
};

export const checkActiveDisclaimer = (
	disclaimers: Disclaimer[],
	legal: string,
): Disclaimer | undefined => {
	const normalize = (str: string) =>
		str
			.replace(/<[^>]*>/g, '') // quitar HTML
			.normalize('NFD') // separar acentos
			.replace(/[\u0300-\u036f]/g, '') // quitar acentos
			.replace(/\s+/g, ' ') // colapsar espacios
			.replace(/[\u200B-\u200D\uFEFF]/g, '') // invisibles
			.trim()
			.toLowerCase();

	return disclaimers.find((d) =>
		normalize(d.text).startsWith(normalize(legal)),
	);
};

export const formatCalculatedDisclaimer = (selectedOferta: Oferta): string =>
	(
		selectedOferta.calculatedFinance.rawResponse?.Response?.Parameters
			?.GlobalDisclaimer ?? ''
	)
		.replace(/^\*/, '')
		.replace(/<u>/g, '**')
		.replace(/<\/u>/g, '**');
